import React from 'react'
import { StepIconProps } from "@material-ui/core";
import { ReactComponent as PmrGreen } from '../../../../../assets/pmr-green-big.svg';
import { ReactComponent as PmrYellow } from '../../../../../assets/pmr-yellow-big.svg';
import { ReactComponent as PmrRed } from '../../../../../assets/pmr-red-big.svg';
import { ReactComponent as PmrGray } from '../../../../../assets/pmr-gray-big.svg';

interface CustomStepIconProps extends StepIconProps {
    classification?: number;
}

const CustomStepIcon = ({ classification }: CustomStepIconProps) => {
    const getIconComponent = () => {
        switch (classification) {
            case 0:
                return <PmrGreen />;
            case 1:
                return <PmrYellow />;
            case 2:
                return <PmrRed />;
            default:
                return <PmrGray />;
        }
    }; 

    return <div>{getIconComponent()}</div>;
};

export default CustomStepIcon;
